<script setup lang="ts">
const mockupData = [
	{
		image: "/static/images/success-box-img1.jpg",
		title: "Clubs",
		description: "Enhance performance through video analysis, provide instant player highlights, and expand your fan base.",
	},
	{
		image: "/static/images/success2.jpg",
		title: "Leagues",
		description: "Elevate your league's status, enable video-assisted goal validation, attract more fans, and engage the younger generation.",
	},
	{
		image: "/static/images/success3.jpg",
		title: "Federations",
		description: "Activate new sponsorships, ensure club satisfaction, foster fan engagement, and multiply your content creation.",
	},
	{
		image: "/static/images/success4.jpg",
		title: "Tournaments",
		description: "Promote sponsors, create lasting visual memories for participating teams, and surprise players with game videos.",
	},
];
</script>

<template>
	<section>
		<div class="container">
			<h2 class="alfa mb-3">
				Laser-focused <br />
				<strong>on your success</strong>
			</h2>

			<SwiperSlider>
				<swiper-slide v-for="(item, index) in mockupData" :key="`ss-item-${index}`">
					<SuccessBox :image="item.image" :title="item.title" :description="item.description" />
				</swiper-slide>
			</SwiperSlider>
		</div>
	</section>
</template>
